/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable react/jsx-no-useless-fragment */

/* eslint-disable react/no-array-index-key */
import axios from 'axios';
import dayjs from 'dayjs';

import {
  Autocomplete,
  Box,
  Button,
  Card,
  Checkbox,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import React, { useEffect, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { getUserProfileById } from '@src/api/Users';
import {
  getAccounts,
  getAudiences,
  getInbox,
  getSender,
  getTemplateLookup,
} from '@src/api/twilio-campaigns';
// import { getUserProfileById } from '@src/api/Users';
import { useAuth } from '@src/contexts/authContext';

const url = `${process.env.REACT_APP_API_URL}`;

function VariableForm({ campaign, setCampaign }) {
  const handleVariableChange = (idx, value) => {
    setCampaign((prev) => ({
      ...prev,
      content_template_variable: {
        ...prev.content_template_variable,
        variables: prev.content_template_variable.variables.map((item) =>
          item.idx === idx ? { ...item, value } : item,
        ),
      },
    }));
  };

  return (
    <>
      {campaign?.content_template_id && (
        <Box mt={1} pl={1}>
          <Typography sx={{ mt: 3 }}>Body</Typography>

          <TextField
            fullWidth
            multiline
            rows={8}
            disabled
            size='medium'
            variant='outlined'
            placeholder='Enter the body with variables like {{1}}, {{2}}, etc.'
            sx={{
              '& .MuiOutlinedInput-root': { borderRadius: '6px' },
              mt: 1,
            }}
            value={campaign?.content_template_definitions?.body}
            onChange={(e) =>
              setCampaign({
                ...campaign,
                body: e.target.value,
              })
            }
          />

          {campaign?.content_template_variable?.variables?.map((v) => {
            return (
              <Box key={v.idx} sx={{ mt: 3 }}>
                <div className='flex items-center'>
                  <Typography fontSize={14} fontWeight={600}>
                    {v.var_code}
                  </Typography>
                  &nbsp;&nbsp;
                  <Typography
                    fontSize={14}
                    display='flex'
                    fontWeight={300}
                    color='gray'
                  >
                    {v.label}
                  </Typography>
                </div>

                <TextField
                  fullWidth
                  disabled={v.value_is_editable === 'false'}
                  value={v?.value || ''}
                  onChange={(e) => handleVariableChange(v.idx, e.target.value)}
                  sx={{
                    '& .MuiOutlinedInput-root': { borderRadius: '6px' },
                    mt: 1,
                  }}
                />
              </Box>
            );
          })}
        </Box>
      )}
    </>
  );
}

function getPreviewMessage(campaign) {
  let message = campaign?.content_template_definitions?.body || '';

  const variables = campaign?.content_template_variable?.variables || [];

  variables.forEach((v) => {
    message = message.replaceAll(`{{${v.idx}}}`, v.value || '');
  });

  const parts = message.split(/(\*.*?\*)/g);

  return parts.map((part, i) => {
    if (part.startsWith('*') && part.endsWith('*')) {
      return <b key={i}>{part.slice(1, -1)}</b>;
    }
    return <span key={i}>{part}</span>;
  });
}

export default function EditCampaign() {
  const { auth } = useAuth();

  // const { pathname: path } = useLocation();
  const navigate = useNavigate();
  const { campaignId } = useParams();

  const [campaign, setCampaign] = useState({});

  const handlePost = () => {
    const formData = {
      account_the_id: campaign?.account_the_id,
      inbox_the_id: campaign?.inbox_the_id,
      sender_the_id: campaign?.sender_the_id,
      cmp_code: campaign?.cmp_code,
      cmp_name: campaign?.cmp_name,
      cmp_description: campaign?.cmp_description,
      content_template_id: campaign?.content_template_id,
      content_template_variable: {
        meta: {
          variable_count:
            campaign?.content_template_variable?.variables?.length || 0,
        },
        variables: (campaign?.content_template_variable?.variables || []).map(
          (v, index) => ({
            idx: index + 1,
            name: (index + 1).toString(),
            label: v.label,
            value: v.value,
            idx_str: String(index + 1).padStart(3, '0'),
            var_code: `{{${index + 1}}}`,
            value_type: v.value_type || 'user_defined',
            default_value: v.default_value || 'user_input',
            example_value: v.example_value,
            value_ui_type: v.value_ui_type || 'text',
            value_is_editable:
              typeof v.value_is_editable === 'boolean'
                ? v.value_is_editable
                : true,
          }),
        ),
      },
      cmp_type: campaign?.cmp_type,
      cmp_status: campaign?.cmp_status,
      cmp_trigger_rules: null,
      cmp_audience: campaign?.cmp_audience,
      cmp_scheduled_at: campaign?.cmp_scheduled_at,
      cmp_trigger_only_during_business_hours: true || false,
      cmp_metadata: null,
      is_active: true || false,
    };

    axios
      .put(
        `${url}/admin/v3/messages/twilio/campaigns/${campaignId}`,
        formData,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${auth.idToken}`,
          },
        },
      )
      .then((response) => {
        console.log('Campaign updated successfully:', response);
        setCampaign({ ...campaign });
        toast.success('Campaign updated successfully', {
          position: 'top-center',
          autoClose: 2000,
        });
        navigate('/campaign-management');
      })
      .catch((error) => {
        console.log(error.message);
        toast.error(
          `${error.response?.data?.system?.message || 'An error occurred'}`,
          {
            position: 'top-center',
            autoClose: 2000,
          },
        );
      });
  };

  const [startDate, setStartDate] = useState(dayjs());

  useEffect(() => {
    if (campaign?.cmp_scheduled_at) {
      setStartDate(dayjs(campaign.cmp_scheduled_at).tz('Asia/Singapore'));
    }
  }, [campaign?.cmp_scheduled_at]);

  const handleStartDateChange = (newDate) => {
    if (newDate && newDate.isValid()) {
      const sgTime = newDate.tz('Asia/Singapore');
      setStartDate(sgTime);
      setCampaign({
        ...campaign,
        cmp_scheduled_at: sgTime.toISOString(),
      });
    }
  };

  const handleBack = async () => {
    navigate('/campaign-management');
  };

  const fetchData = () => {
    if (auth.idToken && campaignId) {
      axios
        .get(`${url}/admin/v3/messages/twilio/campaigns/${campaignId}`, {
          headers: {
            Authorization: `Bearer ${auth.idToken}`,
          },
        })
        .then((response) => {
          setCampaign(response.data?.response?.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const [template, setTemplate] = useState();
  const [accounts, setAccounts] = useState([]);
  const [channel, setChannel] = useState();
  const [audience, setAudience] = useState([]);
  const [sender, setSender] = useState();
  // const id = localStorage.getItem('authentication');
  // const { user } = id ? JSON.parse(id) : {};
  const [users, setUser] = useState({});

  const fetchAccounts = async () => {
    try {
      const res = await getAccounts({
        token: auth.idToken,
      });
      setAccounts(res.data?.response?.data);
    } catch (err) {
      console.error('Error fetching accounts:', err);
    }
  };

  const fetchTemplate = async () => {
    try {
      const res = await getTemplateLookup({
        token: auth.idToken,
      });
      setTemplate(res.data?.response?.data);
    } catch (err) {
      console.error('Error fetching:', err);
    }
  };

  const fetchChannel = async () => {
    try {
      const res = await getInbox({
        token: auth.idToken,
      });
      setChannel(res.data?.response?.data);
    } catch (err) {
      console.error('Error fetching:', err);
    }
  };

  const fetchAudience = async () => {
    try {
      const res = await getAudiences({
        token: auth.idToken,
      });
      setAudience(res.data?.response?.data);
    } catch (err) {
      console.error('Error fetching:', err);
    }
  };

  const fetchSender = async () => {
    try {
      const res = await getSender({
        token: auth.idToken,
      });
      setSender(res.data?.response?.data);
    } catch (err) {
      console.error('Error fetching:', err);
    }
  };

  useEffect(() => {
    if (auth.idToken) {
      getUserProfileById(auth.idToken)
        .then((data) => {
          setUser(data.data);
        })
        .catch((error) => {
          console.error('Error fetching user profile:', error);
        });
    }
    fetchData();
    fetchTemplate();
    fetchAccounts();
    fetchChannel();
    fetchAudience();
    fetchSender();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.idToken, campaignId]);

  const bodyText = (campaign?.content_template_definitions?.body || '').trim();
  const bodyWords = bodyText.split(/\s+/).filter(Boolean);

  const valuesText = (campaign?.content_template_variable?.variables || [])
    .map((v) => v.value || '')
    .join(' ')
    .trim();
  const valueWords = valuesText.split(/\s+/).filter(Boolean);

  const totalWords = bodyWords.length + valueWords.length;

  return (
    <>
      <Box fullwidth margin={2}>
        <Button
          sx={{
            textTransform: 'none',
            paddingLeft: 0,
          }}
          className='px-6 font-bold text-purple-500'
          variant='text'
          // eslint-disable-next-line react/jsx-no-bind
          onClick={handleBack}
        >
          Back
        </Button>

        <div className='grid grid-cols-2 gap-6 pt-8'>
          <Card
            sx={{
              backgroundColor: 'white',
              p: 3,
              borderRadius: 4,
              ml: 3,
            }}
          >
            <Box mt={3} pl={1}>
              <Typography fontFamily='Poppins'>Sender*</Typography>
              <Select
                fullWidth
                displayEmpty
                value={campaign?.sender_the_id || ''}
                onChange={(e) =>
                  setCampaign({
                    ...campaign,
                    sender_the_id: e.target.value,
                  })
                }
                sx={{ mt: 1, borderRadius: '8px' }}
              >
                <MenuItem disabled value=''>
                  <em style={{ color: '#8C8C8C' }}>Select</em>
                </MenuItem>
                {sender?.map((item) => (
                  <MenuItem key={item?.the_id} value={item?.the_id}>
                    {item?.sender_name}
                  </MenuItem>
                ))}
              </Select>
            </Box>

            <Box mt={3} pl={1}>
              <Typography fontFamily='Poppins'>Select Account*</Typography>
              <Select
                fullWidth
                displayEmpty
                value={campaign?.account_the_id || ''}
                onChange={(e) =>
                  setCampaign({
                    ...campaign,
                    account_the_id: e.target.value,
                  })
                }
                sx={{ mt: 1, borderRadius: '8px' }}
              >
                <MenuItem disabled value=''>
                  <em style={{ color: '#8C8C8C' }}>Select</em>
                </MenuItem>
                {accounts?.map((item) => (
                  <MenuItem key={item?.the_id} value={item?.the_id}>
                    {item?.acc_name}
                  </MenuItem>
                ))}
              </Select>
            </Box>

            {/* Title */}
            <Box mt={3} pl={1}>
              <Typography fontFamily='Poppins'>Name*</Typography>
              <TextField
                fullWidth
                size='medium'
                variant='outlined'
                placeholder='Enter the name'
                sx={{
                  '& .MuiOutlinedInput-root': { borderRadius: '6px' },
                  mt: 1,
                }}
                value={campaign?.cmp_name || ''}
                onChange={(e) =>
                  setCampaign({
                    ...campaign,
                    cmp_name: e.target.value,
                  })
                }
              />
            </Box>

            <Box mt={3} pl={1}>
              <Typography fontFamily='Poppins'>Code*</Typography>
              <TextField
                fullWidth
                size='medium'
                variant='outlined'
                placeholder='Enter the code'
                sx={{
                  '& .MuiOutlinedInput-root': { borderRadius: '6px' },
                  mt: 1,
                }}
                value={campaign?.cmp_code || ''}
                onChange={(e) =>
                  setCampaign({
                    ...campaign,
                    cmp_code: e.target.value,
                  })
                }
              />
            </Box>

            <Box mt={3} pl={1}>
              <Typography fontFamily='Poppins'>Description*</Typography>
              <TextField
                fullWidth
                size='medium'
                variant='outlined'
                placeholder='Enter the desc'
                sx={{
                  '& .MuiOutlinedInput-root': { borderRadius: '6px' },
                  mt: 1,
                }}
                value={campaign?.cmp_description || ''}
                onChange={(e) =>
                  setCampaign({
                    ...campaign,
                    cmp_description: e.target.value,
                  })
                }
              />
            </Box>

            {/* Channel */}
            <Box mt={3} pl={1}>
              <Typography fontFamily='Poppins'>Select Channel*</Typography>
              <Select
                fullWidth
                displayEmpty
                value={campaign.inbox_the_id || ''}
                onChange={(e) =>
                  setCampaign({
                    ...campaign,
                    inbox_the_id: e.target.value,
                  })
                }
                sx={{ mt: 1, borderRadius: '8px' }}
              >
                <MenuItem disabled value=''>
                  <em style={{ color: '#8C8C8C' }}>Select</em>
                </MenuItem>
                {channel?.map((item) => (
                  <MenuItem key={item?.the_id} value={item?.the_id}>
                    {item?.inbox_name}
                  </MenuItem>
                ))}
              </Select>
            </Box>

            {/* Audience */}
            <Box mt={3} pl={1}>
              <Typography fontFamily='Poppins'>Choose Audience*</Typography>
              <Autocomplete
                options={audience || []}
                getOptionLabel={(option) => option?.audi_segment_name || ''}
                value={
                  audience?.find((a) => a.the_id === campaign?.cmp_audience) ||
                  null
                }
                onChange={(e, newValue) =>
                  setCampaign({
                    ...campaign,
                    cmp_audience: newValue?.the_id || null,
                  })
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder='Search audience'
                    variant='outlined'
                    fullWidth
                  />
                )}
                sx={{ mt: 1 }}
              />
            </Box>

            {/* Template */}
            <Box mt={3} pl={1}>
              <Typography fontFamily='Poppins'>Choose Template*</Typography>
              <Autocomplete
                value={
                  template?.find(
                    (t) => t.the_id === campaign?.content_template_id,
                  ) || null
                }
                options={template || []}
                getOptionLabel={(option) => option?.ct_name || ''}
                isOptionEqualToValue={(option, value) =>
                  option.the_id === value.the_id
                }
                onChange={(e, selected) => {
                  setCampaign({
                    ...campaign,
                    content_template_id: selected?.the_id || '',
                    content_template_definitions: {
                      body: selected?.ct_template_definition?.body || '',
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder='Search template...'
                    fullWidth
                  />
                )}
                sx={{ mt: 1 }}
              />
            </Box>

            <VariableForm campaign={campaign} setCampaign={setCampaign} />

            {/* Schedule */}
            <Box mt={3} pl={1}>
              <Typography fontFamily='Poppins'>Schedule*</Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  sx={{ width: '100%', mt: 1 }}
                  format='DD MMM YYYY hh:mm A'
                  value={startDate}
                  onChange={(newDate) => {
                    const now = dayjs();
                    if (newDate && newDate.isValid() && newDate.isBefore(now)) {
                      toast.error('Scheduled date cannot be in the past.', {
                        position: 'top-center',
                        autoClose: 2000,
                      });
                      return;
                    }
                    handleStartDateChange(newDate);
                  }}
                  minDateTime={dayjs()}
                />
              </LocalizationProvider>
            </Box>

            {/* Checkboxes */}
            <Box mt={3} pl={1}>
              <Box display='flex' alignItems='center'>
                <Checkbox
                  checked={campaign?.is_active || false}
                  onChange={(e) =>
                    setCampaign({
                      ...campaign,
                      is_active: e.target.checked,
                    })
                  }
                  sx={{ color: '#1788b9' }}
                />
                <Typography fontSize={14}>
                  Enable campaign (is active)
                </Typography>
              </Box>

              <Box display='flex' alignItems='center'>
                <Checkbox
                  checked={
                    campaign?.cmp_trigger_only_during_business_hours || false
                  }
                  onChange={(e) =>
                    setCampaign({
                      ...campaign,
                      cmp_trigger_only_during_business_hours: e.target.checked,
                    })
                  }
                  sx={{ color: '#1788b9' }}
                />
                <Typography fontSize={14}>
                  Trigger only during business hours
                </Typography>
              </Box>
            </Box>
          </Card>

          <div>
            <Typography
              pl={2}
              fontWeight={600}
              fontSize={20}
              fontFamily='Poppins'
            >
              Message Preview
            </Typography>

            <br />
            <br />
            <Box
              sx={{
                border: '10px solid black',
                borderRadius: '30px',
                width: '25vw',
                height: '80vh',
                margin: '0 auto',
                backgroundColor: '#ffffff',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                maxWidth: 390,
                maxHeight: 800,
              }}
            >
              {/* HEADER HP */}
              <Box
                sx={{
                  p: 2,
                  borderBottom: '1px solid #ccc',
                  background: '#fff',
                  borderTopLeftRadius: '20px',
                  borderTopRightRadius: '20px',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <Typography fontSize={14} fontWeight={600}>
                  {campaign.cmp_name || 'Campaign Title'}
                </Typography>
                <Typography pl={5} fontSize={14} fontWeight={600}>
                  {totalWords || '0'}/1024
                </Typography>
              </Box>

              {/* BODY PREVIEW */}
              <Box sx={{ flex: 1, p: 2, overflowY: 'auto' }}>
                <Typography fontSize={14} whiteSpace='pre-line'>
                  {getPreviewMessage(campaign)}
                </Typography>
              </Box>
            </Box>
          </div>
        </div>

        <Card
          sx={{
            display: 'flex',
            justifyContent: 'end',
            mt: 5,
            pr: 15,
            height: '100px',
            p: 3,
            width: '95%',
            borderRadius: 4,
            ml: 3,
          }}
        >
          <Button
            sx={{
              textTransform: 'none',
              mr: 2,
              height: '50px',
              width: '150px',
            }}
            className='rounded-xl bg-red-600 px-6 font-bold text-white'
            onClick={handleBack}
          >
            Cancel
          </Button>
          <Button
            sx={{ textTransform: 'none', height: '50px', width: '150px' }}
            className='rounded-xl bg-cyan-600 px-6 font-bold text-white'
            onClick={handlePost}
          >
            Save
          </Button>
        </Card>
      </Box>

      <br />
    </>
  );
}
